// A dependency-free SVG donut chart.
// segments: [{ label, value, color }]
export default function DonutChart({
  segments = [],
  size = 168,
  thickness = 22,
  centerLabel,
  centerValue,
}) {
  const total = segments.reduce((sum, s) => sum + (s.value || 0), 0);
  const radius = (size - thickness) / 2;
  const circumference = 2 * Math.PI * radius;
  let offset = 0;

  return (
    <div className="donut">
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} role="img">
        <g transform={`rotate(-90 ${size / 2} ${size / 2})`}>
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            stroke="var(--track)"
            strokeWidth={thickness}
          />
          {total > 0 &&
            segments.map((s, i) => {
              const fraction = (s.value || 0) / total;
              const dash = fraction * circumference;
              const seg = (
                <circle
                  key={i}
                  cx={size / 2}
                  cy={size / 2}
                  r={radius}
                  fill="none"
                  stroke={s.color}
                  strokeWidth={thickness}
                  strokeDasharray={`${dash} ${circumference - dash}`}
                  strokeDashoffset={-offset}
                  strokeLinecap="butt"
                />
              );
              offset += dash;
              return seg;
            })}
        </g>
        {centerValue != null && (
          <>
            <text x="50%" y="47%" textAnchor="middle" className="donut__value">
              {centerValue}
            </text>
            <text x="50%" y="60%" textAnchor="middle" className="donut__label">
              {centerLabel}
            </text>
          </>
        )}
      </svg>
      <ul className="donut__legend">
        {segments.map((s, i) => (
          <li key={i}>
            <span className="donut__swatch" style={{ background: s.color }} />
            <span className="donut__legend-label">{s.label}</span>
            <span className="donut__legend-value">{s.value}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
